<template>
    <div id="recordList">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>家教报名记录</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 搜索筛选 -->
        <div class="searchBox">
            <el-form :inline="true" style="margin-top: 20px">
                <el-form-item>
                    <el-input size="small" v-model="name" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size="small" v-model="phone" placeholder="请输入联系方式"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-date-picker v-model="timeDate" type="datetimerange" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期" value-format="timestamp">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" icon="el-icon-search" @click="btnSearch">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" icon="el-icon-upload" @click="btnExport">导出</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="content">
            <!-- 记录列表 -->
            <el-table size="small" :data="recordList" highlight-current-row border element-loading-text="拼命加载中"
                style="width: 100%" height="100%" v-horizontal-scroll>
                <el-table-column align="center" type="index" label="序号"></el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="name" label="姓名" width="160px"></el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="university" label="学校" width="160px"></el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="phone" label="联系方式" width="230px"></el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="grade" label="年级" width="230px"></el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="gender" label="性别" width="230px"></el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="gaokaoScore" label="高考分数" width="230px"></el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="expertSubjects" label="擅长科目" width="230px"></el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="teachingMode" label="线上线下" width="230px"></el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="availableTime" label="上课时间" width="230px"></el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="experience" label="家教经历" width="260px">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="scope.row.experience" placement="bottom">
                            <div style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;;">{{ scope.row.experience }}</div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="introduction" label="说明介绍" width="260px">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="scope.row.introduction" placement="bottom">
                            <div style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;;">{{ scope.row.introduction }}</div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="createTime" label="创建时间" width="230px">
                    <template slot-scope="scope">
                        <div>{{ transformDate(scope.row.createTime) }}</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页组件 -->
        <div class="pageTurning">
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div>

    </div>
</template>

<script>
import { tutoringRecordsApi } from "@/api/registration";
import Pagination from "@/components/Pagination";

export default {
    data() {
        return {
            // 分页参数
            pageparm: {
                currentPage: 0,
                pageSize: 20,
                total: 0,
            },
            pageNum: 1,
            name: "", // 报名姓名
            phone: "", // 报名手机号
            recordList: [],
            timeDate: '', // 时间范围
        };
    },
    created() {
        this.tutoringRecordsData();
    },
    // 注册组件
    components: {
        Pagination
    },
    methods: {

        // 分页插件事件
        callFather(parm) {
            this.pageparm.currentPage = parm.currentPage;
            this.rechargeData();
        },

        // 导出
        btnExport() {
            let that = this

            this.$confirm("是否导出家教报名记录?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                that.exportRecordData()
            }).catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消",
                });
            });
        },
        // 导出记录
        exportRecordData() {
            let that = this
            window.location.href = `http://118.195.249.109:446/app-yijiu-backstage/exportTutorApplicationExcel?token=${localStorage.getItem(
                "logintoken"
            )}&name=${that.name}&page=${that.pageparm.currentPage}&phone=${that.phone}`
        },
        // 报名记录 tutoringRecordsApi
        tutoringRecordsData() {
            let that = this;
            tutoringRecordsApi({
                page: that.pageparm.currentPage * 20,
                name: that.name,
                phone: that.phone,
                startTime: that.timeDate ? that.timeDate[0]/1000 : '', // 开始时间
                endTime: that.timeDate ? that.timeDate[1]/1000 : '', // 结束时间
            }).then((res) => {
                if (res.code == 200) {
                    that.recordList = res.data.data
                    that.pageparm.total = res.data.count
                 
                } else {
                    that.$message({
                        type: "info",
                        message: res.msg,
                    });
                    return;
                }
            });
        },
        // 搜索
        btnSearch() {
            this.pageparm.currentPage = 0
            this.tutoringRecordsData()
        }
    },
};
</script>

<style scoped>
.el-input__inner {
    height: 34px;
    padding-top: 0;
    padding-bottom: 0;
}

#recordList {
    height: 100%;
    display: flex;
    flex-direction: column;
}

#recordList .header {
    flex: none;
}

#recordList .searchBox {
    flex: none;
}

#recordList .content {
    flex: auto;
}

#recordList .pageTurning {
    flex: none;
    text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/views/registration_admin/tutor_record_list.vue